<!--
 * @Description: 常见问题列表
 * @Author: fely
 * @Date: 2020-06-13 15:34:34
 * @LastEditTime: 2020-09-11 14:20:00
 * @LastEditors: fely
--> 
<template>
  <div class="question-page">
    <p class="title">常见问题列表</p>
    <div class="quest-list">
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item title="如何使用亿慧工资条？" name="1">
          <p>手机号注册账号后，上传包含员工手机号信息的Excel工资表即可。亿慧工资条完成工资表信息的解析后，将自动拆分每个员工的工资条，并发送至对应的手机号。</p>
        </el-collapse-item>
        <el-collapse-item title="使用亿慧工资条需要模板吗？" name="2">
          <p>使用亿慧工资条不需要模板，但上传的excel表务必包含电话，建议把本公司的工资条加上电话上传。</p>
        </el-collapse-item>
        <el-collapse-item title="员工如何查看工资条？" name="3">
          <p>（1）员工通过短信接收工资条，点击其中的链接，下载亿慧小秘书app，并用接收工资条的手机号注册成亿慧小秘书app用户，打开“我的工资条”即可查看。 </p>
          <p>（2）已经注册亿慧小秘书app的用户，可以直接打开亿慧小秘书app，进入“我的工资条”进行查看。</p>
        </el-collapse-item>
        <el-collapse-item title="员工接收不到工资条如何处理？" name="4">
          <p>员工如果接收不到工资条，可以去发送记录查看原因，如果手机号填写有误，请更正后重新发送。</p>
        </el-collapse-item>
        <el-collapse-item title="发送的工资条是否可以撤回？" name="5">
          <p>已经发送的工资条可以随时撤回，撤回后员工将不能再看到该工资条。</p>
        </el-collapse-item>
        <el-collapse-item title="为什么系统解析后的表格内容与我上传的工资表不一致？" name="6">
          <p>（1）原因一：工资表中有复合表头，请将表头合并后重新上传。</p>
          <p>（2）原因二：上传的工资表有多个sheet，想解析的内容不在所选的sheet上。</p>
        </el-collapse-item>
        <el-collapse-item title="上传的薪资数据安全吗？" name="7">
          <p>（1）工资条加密：所有投递给员工的工资条都经过加密处理，薪资信息不会意外泄漏。</p>
          <p>（2）传输加密：您和员工与服务器传输的信息经过加密处理，可以避免被拦截或破译。</p>
          <p>（3）可靠安全防护：阿里云为亿慧工资条提供了稳定可靠的安全防护技术，为您的数据保驾护航。</p>
          <p>（4）便捷管理：您拥有您的薪资数据完全的自主权，可以随时进行修改、撤回、重新发送和彻底删除等操作对薪资数据进行管理。 您删除薪资数据后，我们不会以任何形式保存您工资表中的薪资数据。</p>
          <p>（5）隐私保护：亿慧工资条整体运营符合《网络安全法》隐私保护各项条款规定，不会未经授权将您的数据与第三方共享。</p>
        </el-collapse-item>
        <el-collapse-item title="亿慧工资条收费吗？" name="8">
          <p>亿慧工资条目前可以完全免费使用，使用中遇到任何问题我们可以提供免费的维护。</p>
        </el-collapse-item>
      </el-collapse>
      <div class="report">
        <el-input
          type="textarea"
          placeholder="您在使用亿慧工资条的过程中，如果遇到问题或有好的建议可以反馈给我们，我们会尽量解决您的问题。"
          v-model="reportText"
          resize="none"
          :rows="3"
        >
        </el-input>
        <el-button class="submit" type="primary" :loading="isRes" @click="reportSubmit">提交反馈</el-button>
        <!-- <div class="submit" @click="reportSubmit">提交反馈</div> -->
      </div>
      
    </div>
    
  </div>
</template>

<script>
import {addOpinion} from 'api/slip'

export default {
  name: '',
  components: {},
  data() {
    return {
      activeName: '',
      reportText: '',
      isRes: false
    }
  },
  methods: {
    // 提交反馈
    reportSubmit(){
      if(this.reportText!=''){
        this.isRes = true
        addOpinion(this.reportText).then( res => {
          this.isRes = false
          if(res.code == 200){
            this.$message.success('提交成功')
            this.reportText = ''
          }else{
            this.$message.error('提交失败')
          }
        }).catch( err => {
          console.log(err)
        })
      }else{
        this.$message.warning('请填写内容')
      }
      
    }
  },
}
</script>

<style scoped lang="less">
.question-page{
  width: 100%;
  height: 100%;
  p.title{
    font-weight: 600;
    font-size: 12px;
    line-height: 50px;
    height: 50px;
    padding-left: 16px;
    box-sizing: border-box;
  }
  .quest-list{
    padding: 0 25px;
  }
  /deep/ .el-collapse-item__header{
    font-size: 10px !important;
  }
  /deep/ .el-collapse-item__content{
    color: #666;
    font-size: 10px;
  }
  .report{
    margin-top: 40px;
    /deep/ .el-textarea__inner{
      font-size: 10px;
      line-height: 14px;
      padding: 9px 10px;
    }
    .submit{
      display: flex;
      align-items: center;
      justify-content: center;
      width:91px;
      height:32px;
      background:rgba(73,98,254,1);
      color: #fff;
      border-radius: 4px;
      font-size: 12px !important;
      margin: auto;
      margin-top: 30px;
      cursor: pointer;
    }
  }
  /deep/ .el-collapse{
    border-top: 0;
  }
}
</style>
